import { render } from "./AddPrixProduitCondTypeClient2.vue?vue&type=template&id=238cb948&scoped=true&ts=true"
import script from "./AddPrixProduitCondTypeClient2.vue?vue&type=script&lang=ts"
export * from "./AddPrixProduitCondTypeClient2.vue?vue&type=script&lang=ts"

import "./AddPrixProduitCondTypeClient2.vue?vue&type=style&index=0&id=238cb948&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238cb948"]])

export default __exports__